import { render, staticRenderFns } from "./TipoBonoIndex.vue?vue&type=template&id=5108d992"
import script from "./TipoBonoIndex.vue?vue&type=script&lang=js"
export * from "./TipoBonoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports